import React from "react";
import Layout from "../../../components/layouts/Layout";
import { useParams } from "react-router-dom";
import { useRolesDetailsByAdmin } from "../../../hooks/admin/roles.admin";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";
import { useTranslation } from "react-i18next";
import { formatNumber, formatPhoneNumber } from "../../../utils/formatNumber";
import EmptyData from "../../../components/ui/EmptyData";
import PermissionLable from "../../../components/ui/PermissionLable";

export default function RoleDetailsPage() {
  const { roleId } = useParams<{ roleId: string }>();
  const numericRoleId = roleId ? parseInt(roleId) : 0;

  const { data: role, isLoading, isError } = useRolesDetailsByAdmin(numericRoleId, true);

  const {t} = useTranslation();

  console.log(role);

  return (
    <Layout title={""} headline={""}>
      <LoadingErrorState isError={isError} isLoading={isLoading} />

      {role && (
        <div className="space-y-8">
          {/* === Role Info === */}
          <div className="bg-white rounded-2xl shadow-custom-light p-6">
            <h2 className="text-2xl font-semibold text-Black mb-2">{role.name}</h2>
            <p className="text-muted capitalize">
               {t('employees_count')} : {formatNumber(role.admins.length)} |{" "}
               {t('permissions')} : {formatNumber(role.rolePermissions.length)} 
            </p>
          </div>

          {/* === Permissions Section === */}
          <div className="bg-white rounded-2xl shadow-custom-light p-6">
            <h3 className="text-xl font-semibold text-Black mb-4 capitalize">{t("permissions")}</h3>

            {role.rolePermissions.length > 0 ? (
              <div className="flex flex-wrap gap-3">
                {role.rolePermissions.map((perm) => (
                  <span
                    key={perm.id}
                    className="px-4 py-2 bg-primary/10 text-primary font-medium rounded-full text-sm shadow-sm"
                  >
                    {/* {t(perm.permission)} */}
                    <PermissionLable label={perm.permission}/>
                  </span>
                ))}
              </div>
            ) : (
                <EmptyData/>
            )}
          </div>

          {/* === Admins Section === */}
          <div className="bg-white rounded-2xl shadow-custom-light p-6">
            <h3 className="text-xl font-semibold text-Black mb-4 capitalize">{t('employees')}</h3>

            {role.admins.length > 0 ? (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {role.admins.map((admin) => (
                  <div
                    key={admin.id}
                    className="p-5 bg-LightGrey1 rounded-2xl shadow-custom-light border border-LightGrey3"
                  >
                    <div className="font-semibold text-Black text-lg">{admin.name}</div>
                    <div className="text-muted text-sm mt-1">{formatPhoneNumber(admin.phone)}</div>
                    <div
                      className={`mt-3 inline-block px-3 py-1 rounded-full text-sm font-medium ${
                        admin.active
                          ? "bg-success/10 text-success"
                          : "bg-danger/10 text-danger"
                      }`}
                    >
                      {admin.active ? t('active') : t('inactive')}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
                <EmptyData/>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}
